<template>
    <div>
        <!-- 中国建材集团总部2021年人才盘点 - 个人报告 -->
        <Cover :model="data" :isMemberEnterpriseTeam="isMemberEnterpriseTeam" />
        <Contents :isNoP="isNoP" />
        <PageOne />
        <PageTwo
            :model="data"
            :employeeInfos="employeeInfos"
            :evaluate="evaluate"
            :avg="avg"
            :result="result"
            :TaScore="TaScore"
            :isMemberEnterpriseTeam="isMemberEnterpriseTeam"
        />
        <PageThree
            v-if="isNoP === false"
            :model="data"
            :managementSuggestions="managementSuggestions"
            :toBeDeveloped="toBeDeveloped"
            :advantage="advantage"
        />
        <PageFour :model="data" :url="url" :page="4" v-if="isNoP === false" />
        <div v-if="isNoP === false">
            <div v-for="(c, index) in urlAll" :key="index">
                <PageFive :model="data" :url="c" :page="index + 5" />
            </div>
        </div>

        <PageFour :model="data" :url="url" :page="3" v-if="isNoP === true" />
        <div v-if="isNoP === true">
            <div v-for="(c, index) in urlAll" :key="index">
                <PageFive :model="data" :url="c" :page="index + 4" />
            </div>
        </div>
    </div>
</template>
<script>
import Cover from "@/views/CCCST/pages/cover.vue";
import Contents from "@/views/CCCST/pages/contents.vue";
import PageOne from "@/views/CCCST/pages/page-one.vue";
import PageTwo from "@/views/CCCST/pages/page-two.vue";
import PageThree from "@/views/CCCST/pages/page-three.vue";
import PageFour from "@/views/CCCST/pages/page-four.vue";
import PageFive from "@/views/CCCST/pages/page-five.vue";
export default {
    components: {
        Cover,
        Contents,
        PageOne,
        PageTwo,
        PageThree,
        PageFour,
        PageFive,
    },
    data() {
        return {
            model: [],
            data: [],
            employeeInfos: [],
            evaluate: [],
            avg: [],
            result: [],
            winScore1: [],
            managementSuggestions: [],
            toBeDeveloped: [],
            advantage: [],
            TaScore: 0,
            url: "",
            urlAll: [],
            page: 0,
            level: "",
            isNoP: false,
            isMemberEnterpriseTeam: false, // 是不是成员企业班子
        };
    },
    computed: {},
    mounted() {
        this.id = this.getUrlParam("id");
        this.loadApi();
    },
    watch: {},
    methods: {
        loadApi() {
            $.get(`https://talentapi.zhiqijia.com/performance/api/report/info/` + this.id, (res) => {
                if (res.code == 0) {
                    this.data = res.data;
                    document.getElementById("demo").innerHTML = this.data.name + "-中建材总部(个人版)";
                    if (this.data.name === "干志平") {
                        this.isNoP = true;
                    }
                    this.level = this.data.level;
                    if (this.level.indexOf("成员企业班子") >= 0) {
                        this.isMemberEnterpriseTeam = true;
                    }
                    this.employeeInfos = this.data.employeeInfos;

                    if (this.isMemberEnterpriseTeam === true) {
                        this.url =
                            "https://cdn.acmcoder.com/files/2022/cnbm/competency/" +
                            this.data.name +
                            "/" +
                            this.data.name + '_'+
                            2 +
                            ".png";

                        for (let i = 3; i < 19; i++) {
                            this.urlAll.push(
                                "https://cdn.acmcoder.com/files/2022/cnbm/competency/" +
                                this.data.name +
                                "/" +
                                this.data.name + '_'+
                                i +
                                ".png"
                            );
                        }
                    } else {
                        this.url =
                            "https://image.ciictalent.com/report/dacb7f53d1bd4522a5bd2edcefd7f458/行为倾向/" +
                            this.data.name +
                            "/" +
                            2 +
                            ".png";

                        for (let i = 3; i < 8; i++) {
                            this.urlAll.push(
                                "https://image.ciictalent.com/report/dacb7f53d1bd4522a5bd2edcefd7f458/行为倾向/" +
                                this.data.name +
                                "/" +
                                i +
                                ".png"
                            );
                        }
                    }

                    console.log("胜任力报告地址:", this.url);
                    this.winScore1 = res.data.scoreGroup.winScore1;
                    this.winScore1.map((item) => {
                        if (item.name == "总分") {
                            this.TaScore = item.score.toFixed(2);
                        }
                        var num = item.score.toFixed(2);
                        item.score = num;
                    });

                    this.evaluate = res.data.scoreGroup.evaluate;
                    this.evaluate.map((item) => {
                        if (item.level == "平级") {
                            this.avg.push({
                                level: item.level,
                                score: item.avg.toFixed(2),
                            });
                            this.result.push({
                                level: item.level,
                                good1: item.good,
                                bad1: item.bad,
                                name: res.data.name,
                                num: 2,
                            });
                        }

                        if (item.level == "下级" && this.data.name !== "王燚") {
                            this.avg.push({
                                level: item.level,
                                score: item.avg.toFixed(2),
                            });
                            this.result.push({
                                level: item.level,
                                good1: item.good,
                                bad1: item.bad,
                                name: res.data.name,
                                num: 3,
                            });
                        }

                        if (item.level == "自评") {
                            this.avg.push({
                                level: item.level,
                                score: item.avg.toFixed(2),
                            });
                            this.result.push({
                                level: item.level,
                                good1: item.good,
                                bad1: item.bad,
                                name: res.data.name,
                                num: 4,
                            });
                        }

                        if (item.level == "他评") {
                            // this.avg.push({
                            //   level: item.level,
                            //   score: this.TaScore,
                            // });
                            this.result.push({
                                level: item.level,
                                good1: item.good,
                                bad1: item.bad,
                                name: res.data.name,
                                num: 5,
                            });
                        }
                    });

                    this.result.sort(function (a, b) {
                        return a.num > b.num ? 1 : -1;
                    });
                    this.avg.sort(function (a, b) {
                        return parseFloat(a.score) < parseFloat(b.score) ? 1 : -1;
                    });

                    if (res.data.advantage != null) {
                        res.data.advantage.map((item, index) => {
                            this.advantage.push({
                                value: item,
                            });
                        });
                    }

                    if (res.data.toBeDeveloped != null) {
                        res.data.toBeDeveloped.map((item, index) => {
                            this.toBeDeveloped.push({
                                value: item,
                            });
                        });
                    }

                    if (res.data.managementSuggestions != null) {
                        res.data.managementSuggestions.map((item, index) => {
                            this.managementSuggestions.push({
                                value: item,
                            });
                        });
                    }
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        getUrlParam(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]);
            return null;
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/views/CCCST/cccst-personal-report.vue